
import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: '[sdMobileTablet]'
})
export class MobileTabletDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    deviceService: DeviceDetectorService,
  ) {
    if (deviceService.isMobile() || deviceService.isTablet()) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
